import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export interface IAuthContextProps {
	user: string;
	setUser?(...args: unknown[]): unknown;
	setUserData?(...args: unknown[]): unknown;
	updateSidebar: boolean;
	setUpdateSidebar?: (data: boolean) => void;
	userData: any;
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;

}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>(localStorage.getItem('authUsername') || '');
	const [userData, setUserData] = useState({});
	const [updateSidebar, setUpdateSidebar] = useState<boolean>(false);

	useEffect(() => {
		localStorage.setItem('authUsername', user);
	}, [user]);

	useEffect(() => {
		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
			setUserData(JSON.parse(localStorage.getItem('userData') || ''));
		} else {
			setUserData({});
		}
	}, [user]);

	useEffect(() => {
		setUpdateSidebar?.(false);
	}, [updateSidebar]);

	const value = useMemo(
		() => ({
			user,
			setUser,
			updateSidebar,
			setUpdateSidebar: (data: boolean) => setUpdateSidebar(data),
			userData,
		}),
		[user, userData, updateSidebar],
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;
